<template>
    <div style="background-color: #fff; display: flex; flex-direction: column;">
        <!-- <ModalHeader :newLoginForm="true" :isBackBtnHidden='true' title="로그인 / 회원가입"></ModalHeader> -->
        <div style=" flex: 1">
            <div style="padding: 20px; padding-bottom: 32px;">
                <div style="font-weight: 500; margin-bottom: 8px; margin-top: 40px; text-align: center;">
                    <div style="font-size: 32px; font-weight: 700; line-height: 46px;">사커하우</div>
                    <div style="line-height: 24px;">내가 알던 축구의 확장</div>
                </div>
                <div style="display: flex; gap: 12px; justify-content: center;">
                    <img style="width: 40px;" v-for="index in 6" :key="index" :src="require(`@/assets/login-ico-${index}.png`)" alt="">
                </div>
            </div>
            <div style="text-align: center;">
                <div style="text-align:center;">
                    <div @click="loginKaKao" class="login_btn_style" style="display:flex; align-items:center;background-color:#FFDA3A; position: relative; color: #101014; font-size: 14px; margin-bottom: 12px; margin-top:5px; height:63px;">
                        <img :src="require('@/assets/img/kakao_login.png')" style="width: 18px; position:absolute; left:20px; transform: translateY(-50%); top: 50%;" alt="">
                        <span style="flex:1; font-weight:500;">카카오로 로그인하기</span>
                    </div>
                    <div @click="registById" class="login_btn_style" style="display:flex; align-items:center;background-color:#f4f4f4; position: relative; color: #101014; font-size: 14px; margin-bottom: 12px; margin-top:5px; height:63px;">
                        <img :src="require('@/assets/position_on.png')" style="width: 24px;position:absolute; left:18px; transform: translateY(-50%); top: 50%; " alt="">
                        <span style="flex:1; font-weight:500;">사커하우 이메일로 가입하기</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RegistTypeSelect",
        props : {
            register_type : {
                type : Number,
                default : -1
            }
        },
        methods : {
            loginKaKao(){
                const device = this.$cookies.get('device');

                if (device === 'android') {
                    this.$GlobalStore.addModal('KaKaoLogin', { transitionName: '' });
                } else if (device === 'ios') {
                    this.$GlobalStore.addModal('KaKaoLogin', { transitionName: '' });
                } else {
                    const userAgent = navigator.userAgent;
                    if (userAgent.match(/iPhone|iPad|iPod/i)) {
                        window.open('/login/kakao/form')
                    }else {
                        this.$GlobalStore.addModal('KaKaoLogin', { transitionName: '' });
                    }
                }
            },
            registById(){
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.addModal('MemberRegist', {transitionName: 'bottom', register_type: this.register_type });
            }
        }
    }
</script>

<style scoped>
    .login_btn_style {
        margin: 20px;
        font-weight: 500;
        height: 39px;
        line-height: 39px;
        color: #fff;
        border-radius: 12px;
        width: calc(100% - 40px);
        text-align: center;
    }
</style>